import { Link } from "react-router-dom";

const LOGO_URL =
  "/logo.png";

export default function Logo({ small = false }) {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center">
      <img
        src={LOGO_URL}
        alt="Smart Infovision"
        className={small ? "h-12 w-auto" : "h-16 md:h-20 w-auto"}
      />
    </Link>
  );
}
